<template>
    <v-flex align-center class="icon-label "
            :no_pointer="no_pointer"
            :class="{'no_pointer': no_pointer}"
    >
        <svg v-svg
             :symbol="icon_name"
             :size="size"
             class="icon"
             role="presentation"
        />
        <span><slot></slot></span>
    </v-flex>
</template>

<script>

export default {
  props: {
    no_pointer: {
      type: Boolean,
    },
    icon_name: {
      type: String,
    },
    size: {
      type: String,
    },
  },
};
</script>

